var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { HttpCacheType, HttpMethodType, HttpContentType, HttpHeaderType, handleResponse, EnvironmentService, getRandomUuidV4 } from "../../common";
import { QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL, QUESTIONNAIRE_URL_PREFIX } from '../constants';
export class QuestionnaireEvaluationInitializationService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    static getInstance() {
        if (!QuestionnaireEvaluationInitializationService.INSTANCE) {
            QuestionnaireEvaluationInitializationService.INSTANCE = new QuestionnaireEvaluationInitializationService();
        }
        return QuestionnaireEvaluationInitializationService.INSTANCE;
    }
    questionnaireEvaluationInitializationPost(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestBody = {
                mapSysQustnCdsAndValues: requestData.mapSysQustnCdsAndValues,
                qustnnrId: requestData.qustnnrId,
                evalDocId: requestData.evalDocId,
                claimId: requestData.claimId,
                suffixId: requestData.suffixId,
                userAnswrdSystmQustn: requestData.userAnswrdSystmQustn,
                extrnlEvalId: requestData.externalEvaluationId
            };
            const uri = `${EnvironmentService.getEnvironment().connectServicesUrl}v1/apd/questionnaire/question/companies/${requestData.coCode}/QuestionnaireEvaluations`;
            const request = new Request(uri, {
                method: HttpMethodType.POST,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.XMI_REQUEST_ID]: getRandomUuidV4(),
                    [HttpHeaderType.XMI_CALLER]: QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL
                }),
                body: JSON.stringify(requestBody)
            });
            return yield this.fetchWrapper(request).then(response => handleResponse(response));
        });
    }
    /*
        Service call to get evaluation id
    */
    questionnaireEvaluationGetEvaluationId(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestBody = {
                mapSysQustnCdsAndValues: requestData.systemCodeValueMap,
                qustnnrId: requestData.questionnaireId,
                claimId: requestData.claimId,
                suffixId: requestData.exposureId,
                evalDocId: requestData.evaluationDocId,
                coCode: requestData.companyCode
            };
            const uri = `${EnvironmentService.getEnvironment().connectServicesUrl}${QUESTIONNAIRE_URL_PREFIX}/${requestData.companyCode}/QuestionnaireEvaluations`;
            const request = new Request(uri, {
                method: HttpMethodType.POST,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.XMI_REQUEST_ID]: getRandomUuidV4(),
                    [HttpHeaderType.XMI_CALLER]: QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL
                }),
                body: JSON.stringify(requestBody)
            });
            return yield this.fetchWrapper(request).then(response => handleResponse(response));
        });
    }
    /**
     * Function to call the API to get the evaluation id on the basis of external evalution id
     * @param requestData IQuestionnaireEvaluationEvalIdByExternalEvalId it has data to be send to API
     * @returns number evalaution id
     */
    questionnaireEvaluationGetEvalIdFromExternalEvalId(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `${EnvironmentService.getEnvironment().connectServicesUrl}${QUESTIONNAIRE_URL_PREFIX}/${requestData.companyCode}/QuestionnaireEvaluations/${requestData.externalEvaluationId}/evaluationId`;
            const request = new Request(url, {
                method: HttpMethodType.GET,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON,
                    [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE,
                    [HttpHeaderType.XMI_REQUEST_ID]: getRandomUuidV4(),
                    [HttpHeaderType.XMI_CALLER]: QUESTIONNAIRE_EVALUATION_MI_CALLER_LABEL
                })
            });
            return yield this.fetchWrapper(request).then(response => handleResponse(response));
        });
    }
}
//# sourceMappingURL=QuestionnaireEvaluationInitializationService.js.map